export const ACCOUNT_TEAM_FULL_MESSAGE = `You cannot add a new Account Team Member because all available types are already in use.
Please review the existing team members and their types before adding a new one.`;
